$(->
  ## Changes the edit link path under 'Job Builder Questions' and 'Overview Builder Questions' 
  ## when the edit path already exists and the group of questions is changed.
  $('body.job_builders .form-group.select select,body.overview_builders .form-group.select select').change(->
    if parseInt($(this).val()) > 0
      es = $(this).closest('.form-group.select').find('a.edit-selected')
      if es.length > 0
        es.attr('href', es.attr('href').replace(/(.*?)\/[-\d]+\/edit/, "$1/" + $(this).val() + "/edit"))
  ).change()
)
